import React, {useEffect} from 'react';
import track from 'utils/track';
import SalesIndex from './impact';

export default function () {
  useEffect(
    () =>
      track('Product Viewed', {
        product_id: 'HF-FF-IK',
        sku: 'HF-FF-IK',
        name: 'Fantastic Fungi Impact Kit',
        variant: 'ff-impactkit-launch',
        value: 97,
        currency: 'usd'
      }),
    []
  );
  return <SalesIndex ctaOverride="sales97" ctaNoTimer />;
}
